var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#trash_svg__clip0_16859_131890)",
    fill: "#7D888E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 6H1c-.55 0-1-.45-1-1s.45-1 1-1h18c.55 0 1 .45 1 1s-.45 1-1 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 22H5c-1.65 0-3-1.35-3-3V5c0-.55.45-1 1-1s1 .45 1 1v14c0 .55.45 1 1 1h10c.55 0 1-.45 1-1V5c0-.55.45-1 1-1s1 .45 1 1v14c0 1.65-1.35 3-3 3ZM14 6c-.55 0-1-.45-1-1V3c0-.55-.45-1-1-1H8c-.55 0-1 .45-1 1v2c0 .55-.45 1-1 1s-1-.45-1-1V3c0-1.65 1.35-3 3-3h4c1.65 0 3 1.35 3 3v2c0 .55-.45 1-1 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 17c-.55 0-1-.45-1-1v-6c0-.55.45-1 1-1s1 .45 1 1v6c0 .55-.45 1-1 1Zm4 0c-.55 0-1-.45-1-1v-6c0-.55.45-1 1-1s1 .45 1 1v6c0 .55-.45 1-1 1Z"
  }))));
};
export default SvgTrash;